import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DebtsService {
  constructor(private http: HttpClient) {}

  getDebtsData(formsId: number): Observable<any> {
    return this.http.get(`${environment.api_guia}forms/${formsId}/loans`);
  }

  updateDebtsData(
    formsId: number,
    debtsId: number,
    data: any
  ): Observable<any> {
    return this.http.patch(
      `${environment.api_guia}forms/${formsId}/loans/${debtsId}`,
      data
    );
  }
}
